var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component__collapsible" },
    [
      _c(
        "h3",
        {
          staticClass: "mb-0",
          class: {
            "d-flex align-item-center justify-content-between": !_vm.isDisabled,
            active: _vm.isActive,
            "toggle--disabled": _vm.isDisabled,
          },
          attrs: {
            role: "button",
            "aria-expanded": _vm.isActive ? "true" : "false",
            "aria-controls": "collapsible-content-" + _vm._uid,
          },
          on: {
            click: _vm.toggle,
            keydown: [
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.toggle.apply(null, arguments)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar",
                  ])
                )
                  return null
                $event.preventDefault()
                return _vm.toggle.apply(null, arguments)
              },
            ],
          },
        },
        [
          _vm.img
            ? [_c("img", { attrs: { src: _vm.img, alt: "" } })]
            : _vm._e(),
          _vm._v(" "),
          _c("div", [_c("strong", [_vm._t("title")], 2)]),
          _vm._v(" "),
          !_vm.isDisabled
            ? _c("div", { staticClass: "toggle text-lowercase" }, [
                _vm.showToggleDescription
                  ? _c("span", { staticClass: "toggle_text" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.isActive ? "Hide" : "Show") +
                          "\n      "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "toggle__icon" }),
              ])
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("collapse-transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isActive || _vm.isDisabled,
                expression: "isActive || isDisabled",
              },
            ],
            staticClass: "accordion__description",
            attrs: { id: "collapsible-content-" + _vm._uid },
          },
          [_vm._t("default")],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }